var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import * as S from './Skeleton.styled';
export const Skeleton = (_a) => {
    var { gap = 0, aligment = 'vertical', children } = _a, props = __rest(_a, ["gap", "aligment", "children"]);
    return (React.createElement(S.Skeleton, Object.assign({ "$gap": gap, "$aligment": aligment, "data-testid": "Skeleton" }, props), children));
};
export const SkeletonShape = (_a) => {
    var { variant = 'rectangle', radius, width = '100%', height = 'auto' } = _a, props = __rest(_a, ["variant", "radius", "width", "height"]);
    return (React.createElement(S.Shape, Object.assign({ "$variant": variant, "$radius": radius, "$width": width, "$height": height, "data-testid": "Skeleton.Shape" }, props), "\u200C"));
};
Skeleton.Shape = SkeletonShape;
//# sourceMappingURL=Skeleton.js.map